import { html, SYSConfig } from "../../../"
import { T } from "../../../textapi"

import type { SYSFormState } from "../actions"
import { FieldSetVal } from "../fieldapi"
import { _setFieldFocus } from "../helper"

import { SYSControlBase } from "./syscontrolbase"

export class SYSEditorAsset extends SYSControlBase {
  async getUI() {
    super.InitControl()
    let field = this.field
    // /* needed for tracking... */
    // field.value
    let formState: SYSFormState =
      this.state.ovl.forms[field.formType][field.formId]
    if (!formState) {
      return
    }
    let displayValue

    let nullClicker = html`<span></span>`
    let isNullInput = ""
    if (field.nullHandling.enabled && field.convertedValue !== null) {
      isNullInput = "ovl-null-input"
      nullClicker = html`
        <span
          title="${T("SYSSetToNull")}"
          class="sap-icon--sys-cancel-2"
          role="presentation"
          @click=${(e) => {
            e.stopPropagation()
            FieldSetVal(field, null, { watched: true })
            field._state._files = undefined
          }}
        ></span>
      `
    }

    if (this.valueRenderHookFn) {
      displayValue = this.getHookValue()
    } else {
      if (
        SYSConfig.global.assetValueDisplay === "ExtractFileNameAndExtension"
      ) {
        if (field.value) {
          let valueAsObject = JSON.parse(field.value)
          if (Array.isArray(valueAsObject)) {
            valueAsObject = valueAsObject[0]
          }
          if (valueAsObject.val) {
            displayValue = `${valueAsObject.val}.${valueAsObject.ext}`
          }
        }
      } else {
        displayValue = field.value
      }
    }

    return html`
      <div
        class="${this.getContainerClass(
          "asset",

          this.customInfo.customRowClassContainerName
        )} ${isNullInput}"
      >
        <div
          id="ovl-assetinput-value-${field.id}"
          tabindex="0"
          @click=${(e) => this.handleEditor(e)}
          @focusout=${() => {
            this.actions.ovl.form._ChangeField({
              fieldKey: this.field.fieldKey,
              formState: this.formState,
              value: this.field.value,
              watched: true,
              noRetrigger: true,
            })
            _setFieldFocus(this.field, false)
          }}
          @focus=${() => _setFieldFocus(this.field, true)}
          class="fd-input ovledit-value  ${this.getInputClass(
            "asset",

            this.customInfo.customRowClassName
          )}"
        >
          ${displayValue} ${nullClicker}
        </div>

        <ovl-controllabel .props=${() => this.field}> </ovl-controllabel>
        <ovl-controlcustomhint .props=${() => this.field}>
        </ovl-controlcustomhint>
        <ovl-controlvalidationhint .props=${() => this.field}>
        </ovl-controlvalidationhint>
      </div>
    `
  }
}
